import { Columns } from "@fullscript/aviary-web";
import {
  faChevronDown,
  faChevronUp,
  faHeadSideMedical,
  faHomeHeart,
} from "@fullscript/pro-regular-svg-icons";
import { faCircle } from "@fullscript/pro-solid-svg-icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { NoStyleButton, Typography } from "@aviary";
import { CheckmarkList } from "@shared/components/CheckmarkList/CheckmarkList";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";
import { l } from "@unauthenticated/oauth/locales/i18n";

import * as styles from "./OAuthAuthorizationScope.styles";

interface OauthScopeDescription {
  title: string;
  subTitle: string;
  description: string;
  includes: string[];
  kind?: string;
}

const OAuthAuthorizationScope = ({
  title,
  subTitle,
  description,
  includes,
  kind,
}: OauthScopeDescription) => {
  const { t } = useTranslation();
  const [showContent, setShowContent] = useState<boolean>(false);

  const renderIncludes = () => (
    <CheckmarkList>
      {includes.map((include, index) => (
        <li key={index}>
          <Typography css={styles.text}>{include}</Typography>
        </li>
      ))}
    </CheckmarkList>
  );

  return (
    <NoStyleButton css={styles.button} onClick={() => setShowContent(!showContent)}>
      <Columns key={title} customCss={styles.item}>
        <Columns.Column columnWidth={1} customCss={styles.iconContainer}>
          <span className="fa-layers fa-fw" css={styles.iconStack}>
            <FontAwesomeIcon icon={faCircle} css={styles.iconBackgroundPath} />
            <FontAwesomeIcon
              icon={kind === "patient" ? faHeadSideMedical : faHomeHeart}
              transform="shrink-8"
              css={styles.iconPath}
            />
          </span>
        </Columns.Column>
        <Columns.Column>
          <Typography css={styles.text} type="h3">
            {title}
          </Typography>
          <Typography css={styles.text}>{subTitle}</Typography>
          <section css={[styles.content.base, showContent && styles.content.isActive]}>
            <Typography>{description}</Typography>
            {renderIncludes()}
          </section>
          <Typography type="h5" css={styles.indicator}>
            {t(showContent ? l.oauth.ReadLess : l.oauth.ReadMore)}
          </Typography>
        </Columns.Column>
        <Columns.Column columnWidth={1} customCss={styles.accordionContainer}>
          <FontAwesomeIcon css={styles.icon} icon={showContent ? faChevronUp : faChevronDown} />
        </Columns.Column>
      </Columns>
    </NoStyleButton>
  );
};

export { OAuthAuthorizationScope };
